import { render, staticRenderFns } from "./PlacementsStartComponentPerformanceItem.vue?vue&type=template&id=f8da7d66&"
import script from "./PlacementsStartComponentPerformanceItem.vue?vue&type=script&lang=js&"
export * from "./PlacementsStartComponentPerformanceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports